export const VARIANTS = ['primary', 'secondary', 'tertiary', 'success', 'error', 'warning', 'default'] as const;
export type VariantType = (typeof VARIANTS)[number];

export const BUTTON_BASE_ICON_SIZE = {
  small: 12,
  medium: 16,
  large: 24
};
